<template>
  <div style="height: 100%;overflow: auto;">
    <div class="mt-20 ">
      <el-table :data="list" border stripe row-style="max-height:100px;">
        <el-table-column label="ID" prop="id" width="80"></el-table-column>
<!--        <el-table-column label="微页" prop="one_page.title"></el-table-column>-->
        <el-table-column label="电子书" prop="ebook.title"></el-table-column>
        <el-table-column label="分配次数" prop="use_num"></el-table-column>
        <el-table-column label="创建时间" prop="addtime_format"></el-table-column>
        <el-table-column label="操作" width="220px">
          <template v-slot="scope">
            <el-popconfirm title="确认删除？" @confirm="del(scope.row.id)">
              <el-button type="danger" size="small" slot="reference">删除</el-button>
            </el-popconfirm>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <div style="height: 60px;"></div>
    <layer-page :total="total" :currentPage="page" @change="page_change"></layer-page>
  </div>
</template>

<script>
import LayerPage from "@/components/layer-page";
export default {
name: "send_record",
components:{LayerPage},
  data(){
    return{
      list:[],
      is_load:false,
      page:1,
      total:0,
    }
  },
  mounted:async function (){
    try{
      await this.get_list();
    }catch (e){
      console.log(e);
      return false;
    }
  },
  methods: {
    get_list: async function () {
      if (!this.is_load) {
        this.is_load = true;
        this.$_showLoading();
        let res = await this.$_api.company('send_record', {page: this.page,uid:this.user.uid});
        this.is_load = false;
        this.$_hideLoading();
        this.list = res.list;
        this.total = res.total;
      }
    },
    page_change: async function (e) {
      try {
        this.page = e;
        this.is_load = false;
        this.list = [];
        await this.get_list();
      } catch (e) {
        console.log(e);
        return false;
      }
    },
  }
}
</script>

<style scoped>

</style>